import { render, staticRenderFns } from "./AuditScoreResults.vue?vue&type=template&id=72272cbf&scoped=true&"
import script from "./AuditScoreResults.vue?vue&type=script&lang=ts&"
export * from "./AuditScoreResults.vue?vue&type=script&lang=ts&"
import style0 from "./AuditScoreResults.vue?vue&type=style&index=0&id=72272cbf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72272cbf",
  null
  
)

export default component.exports